<template>
  <PageLayout class="propositions-page">
    <PageTitle class="page-title">Центр котирування</PageTitle>
    <Quotations />
  </PageLayout>
</template>

<script>
import { mapActions } from 'vuex';
import { pages } from '@/entities/current-page';
import { PageLayout } from '@/shared/ui/layouts';
import { PageTitle } from '@/shared/ui/page-title';
import Quotations from "../../views/quotations";

export default {
  created() {
    this.changeActivePage(pages.ORDERS);
  },
  components: { PageLayout, PageTitle, Quotations },
  methods: {
    ...mapActions('currentPageModule', ['changeActivePage']),
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 30px;
  line-height: 44px;
  color: #24282c;
  font-weight: 700;
  margin-bottom: 26px !important;
}

::v-deep button {
  text-align: center;
}

::v-deep input {
    border: 1px solid #dde2e5 !important;
    border-radius: 3px !important;

    &:hover {
        border-color: #ffad3d !important;
    }
}

::v-deep .multiselect__input {
    border: none !important;
}

@media (max-width: 1220px) and (min-width: 992px) {
  ::v-deep .list-propositions .tabs-block {
    max-width: none;
    width: 100%;
  }
}
</style>
